import { PageModel } from "./PageModel";

class PrivacyPolicyController extends PageModel {

}

export {PrivacyPolicyController}
